import { memo } from 'react';

import { ParentLinkHeader } from './ParentLinkHeader';

export * from './ParentLinkHeader';

export default memo(ParentLinkHeader);
